const NETPLUS_ORIGIN = 'https://netplus.choses.ch';
const DEFAULT_CACHE_BASE_URL = 'http://127.0.0.1:8765';

// Use only for media sources, never for page navigation or directory/API requests.
function resolveMediaUrl(source, {
  enabled = process.env.VUE_APP_KIOSK_CACHE_ENABLED === 'true',
  baseUrl = process.env.VUE_APP_KIOSK_CACHE_BASE_URL || DEFAULT_CACHE_BASE_URL,
} = {}) {
  if (!enabled || typeof source !== 'string') return source;

  const relativeContent = source.startsWith('/content/');
  if (!relativeContent && !/^https?:\/\//i.test(source)) return source;

  let url;
  try {
    url = new URL(source, NETPLUS_ORIGIN);
  } catch {
    return source;
  }
  if (!['http://netplus.choses.ch', NETPLUS_ORIGIN].includes(url.origin)
      || !url.pathname.startsWith('/content/')) return source;

  // Queries can be signatures/version selectors, fragments can control playback.
  // Reject explicitly rather than silently changing the media's semantics.
  if (source.includes('?') || source.includes('#') || url.username || url.password) {
    throw new Error('Cache kiosque : le média doit avoir une URL sans paramètres, fragment ni identifiants. Utilisez un nom de fichier versionné si nécessaire.');
  }

  let cacheBase;
  try {
    cacheBase = new URL(baseUrl);
  } catch {
    throw new Error('Cache kiosque : URL de base invalide.');
  }
  if (!['http:', 'https:'].includes(cacheBase.protocol)
      || cacheBase.pathname !== '/' || cacheBase.search || cacheBase.hash
      || cacheBase.username || cacheBase.password || /[?#]/.test(baseUrl)) {
    throw new Error('Cache kiosque : indiquez une origine HTTP(S), sans chemin, paramètres ni fragment.');
  }
  return `${cacheBase.origin}${url.pathname}`;
}

module.exports = { resolveMediaUrl };
